<template>
  <div class="print-break-after">
    <!-- Pop-up calendario-->
    <wg-modal
      :width="'90%'"
      v-if="showCalendar"
      @closeModal="showCalendar = !showCalendar"
    >
      <div
        slot="header"
        class="wg-row"
        style="flex-wrap:nowrap;align-items:center;"
      >
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, "Calendar", "Calendario") }}
        </div>
        <div
          class="wg-row"
          style="flex-wrap:nowrap;align-items:center;justify-content:center;"
        >
          <img
            class="com-anm22-app-img-fixed-height-s"
            style="cursor:pointer;"
            :src="$anm22.icons.getWorldIcon('arrowLeft')"
            @click="offset--"
          />
          <div class="com-anm22-app-horizontal-space" style="width:10px;"></div>
          <div class="com-anm22-app-text-xl">
            {{ month | moment("MMMM YYYY") }}
          </div>
          <div class="com-anm22-app-horizontal-space" style="width:10px;"></div>
          <img
            class="com-anm22-app-img-fixed-height-s"
            style="cursor:pointer;"
            :src="$anm22.icons.getWorldIcon('arrowRight')"
            @click="offset++"
          />
        </div>
      </div>
      <vircos-calendar
        slot="body"
        :active="true"
        :month="month"
        @setDeliveryDate="setDeliveryDate"
      ></vircos-calendar>
    </wg-modal>
    <!-- DATA ORDINE -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Delivery date", "Data di consegna") }}
          </div>
          <div
            class="com-anm22-app-text-m display-flex hidden-input model-row"
            @click="openCalendar"
          >
            {{ deliveryDate }}
          </div>
        </div>
      </div>
    </div>
    <div class="wg-row" style="padding:5px;">
      <div class="com-anm22-app-text-m" style="font-weight: 600;">
        {{ $anm22.strLang(lang, "Articles list", "Lista articoli") }}
      </div>
    </div>
    <!-- TUTA -->
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div
            class="com-anm22-app-text-m"
            style="display:inline-block;vertical-align:middle"
          >
            {{ $anm22.strLang(lang, "Suit", "Tuta") }}
          </div>
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="deliveryData.suitModel"
          >
            <option :value="null">{{
              $anm22.strLang(lang, "Select model", "Seleziona modello")
            }}</option>
            <option
              v-for="(p, i) in suitProducts"
              :key="'abp-' + i"
              :value="p.idWarehouseProduct"
              >{{ p.name }}</option
            >
          </select>
          <template v-else>
            <input
              v-if="
                suitProducts.find(
                  (p) => p.idWarehouseProduct === deliveryData.suitModel
                )
              "
              disabled
              class="input-elem com-anm22-app-input-text model-row"
              type="text"
              v-model="
                suitProducts.find(
                  (p) => p.idWarehouseProduct === deliveryData.suitModel
                ).name
              "
            />
          </template>
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Price", "Prezzo") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-number"
            type="number"
            min="0"
            placeholder="0"
            v-model="deliveryData.price"
          />
        </div>
      </div>
    </div>
    <!-- AIRBAG -->
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div
            class="com-anm22-app-text-m"
            style="display:inline-block;vertical-align:middle"
          >
            AirBag
          </div>
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="deliveryData.airbag"
          >
            <option :value="null">{{
              $anm22.strLang(lang, "No", "No")
            }}</option>
            <option
              v-for="(p, i) in airbagProducts"
              :key="'abp-' + i"
              :value="p.idWarehouseProduct"
              >{{ p.name }}</option
            >
          </select>
          <template v-else>
            <input
              v-if="
                airbagProducts.find(
                  (p) => p.idWarehouseProduct === deliveryData.airbag
                )
              "
              disabled
              class="input-elem com-anm22-app-input-text model-row"
              type="text"
              v-model="
                airbagProducts.find(
                  (p) => p.idWarehouseProduct === deliveryData.airbag
                ).name
              "
            />
          </template>
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Price", "Prezzo") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-number"
            type="number"
            min="0"
            placeholder="0"
            v-model="deliveryData.airbagPrice"
          />
        </div>
      </div>
    </div>
    <!-- ACCESSORIES -->
    <div
      v-for="(accessoryItem, aii) in deliveryData.accessories"
      :key="'acc-' + aii"
      class="wg-row input-row"
    >
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div
            class="com-anm22-app-text-m"
            style="display:inline-block;vertical-align:middle"
          >
            {{ $anm22.strLang(lang, "Accessory", "Accessorio") }}
          </div>
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="deliveryData.accessories[aii].product"
          >
            <option :value="null">{{
              $anm22.strLang(lang, "Select product", "Seleziona prodotto")
            }}</option>
            <option
              v-for="(p, i) in accessoryProducts"
              :key="'acp-' + i"
              :value="p.idWarehouseProduct"
              >{{ p.name }}</option
            >
          </select>
          <template v-else>
            <input
              v-if="
                accessoryProducts.find(
                  (p) =>
                    p.idWarehouseProduct ===
                    deliveryData.accessories[aii].product
                )
              "
              disabled
              class="input-elem com-anm22-app-input-text model-row"
              type="text"
              v-model="
                accessoryProducts.find(
                  (p) =>
                    p.idWarehouseProduct ===
                    deliveryData.accessories[aii].product
                ).name
              "
            />
          </template>
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Price", "Prezzo") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-number"
            type="number"
            min="0"
            placeholder="0"
            v-model="deliveryData.accessories[aii].price"
          />
          <img
            :src="$anm22.icons.getWorldIcon('deleteBin')"
            class="com-anm22-app-img-s"
            @click="deleteAccessory(aii)"
            style="cursor:pointer"
          />
        </div>
      </div>
    </div>
    <!-- ADD ACCESSORY -->
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div
            class="com-anm22-app-text-m"
            @click="addAccessory()"
            style="cursor:pointer"
          >
            {{
              $anm22.strLang(lang, "+ Add accessory", "+ Aggiungi accessorio")
            }}
          </div>
        </div>
      </div>
    </div>
    <!-- CORRIERE -->
    <div
      v-if="deliveryData.deliveryType === 'shipping'"
      class="wg-row input-row"
    >
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div
            class="com-anm22-app-text-m"
            style="display:inline-block;vertical-align:middle"
          >
            {{ $anm22.strLang(lang, "Shipping", "Spedizione") }}
          </div>
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="deliveryData.deliveryCarrier"
          >
            <option :value="undefined">{{
              $anm22.strLang(lang, "Select carrier", "Selezione corriere")
            }}</option>
            <option
              v-for="(dm, i) in deliveryCarriers"
              :key="'dm-' + i"
              :value="dm.id"
              >{{ dm.label }}</option
            >
          </select>
          <template v-else>
            <input
              v-if="
                deliveryCarriers.find(
                  (dm) => dm.id === deliveryData.deliveryCarrier
                )
              "
              disabled
              class="input-elem com-anm22-app-input-text model-row"
              type="text"
              v-model="
                deliveryCarriers.find(
                  (dm) => dm.id === deliveryData.deliveryCarrier
                ).label
              "
            />
          </template>
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Price", "Prezzo") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-number"
            type="number"
            min="0"
            placeholder="0"
            v-model="deliveryData.deliveryPrice"
          />
        </div>
      </div>
    </div>
    <!-- PREZZO TOTALE -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6"></div>
      <div v-if="mode === 'edit'" class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Total price", "Prezzo totale") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-number"
            type="number"
            min="0"
            placeholder="0"
            disabled
            :value="totalPrice"
          />
        </div>
      </div>
    </div>
    <!-- REPAIR HOURS -->
    <div
      v-if="
        mode === 'edit' && this.project.category && this.project.category == 2
      "
      class="wg-row"
    >
      <div class="wg-col wg-xs-12 wg-sm-6"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Repair hours", "Ore riparazione") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-text"
            type="number"
            placeholder="0"
            v-model="deliveryData.repairHours"
          />
        </div>
      </div>
    </div>
    <div class="wg-row" style="padding:5px;">
      <div class="com-anm22-app-text-m" style="font-weight: 600;">
        {{ $anm22.strLang(lang, "Invoicing data", "Dati di fatturazione") }}
      </div>
    </div>
    <!-- INVOICING TYPE -->
    <div class="wg-row input-row measure" style="height:36px;">
      <div class="wg-col wg-xs-2">
        <div class="com-anm22-app-text-l">
          {{ $anm22.strLang(lang, "Document", "Documento") }}
        </div>
      </div>
      <div class="wg-col wg-xs-10">
        <div class="wg-row" style="align-items:center;">
          <input
            :disabled="mode === 'view'"
            id="receipt-receipt"
            type="radio"
            value="receipt"
            style="display:none;"
            v-model="deliveryData.receiptType"
          />
          <label class="label-input-radio" for="receipt-receipt">{{
            deliveryData.receiptType === "receipt" ? "✔" : ""
          }}</label>
          <div class="com-anm22-app-text-l" style="margin:0 5px;">
            {{ $anm22.strLang(lang, "Receipt", "Ricevuta") }}
          </div>
          <div class="com-anm22-horizontal-div" style="width: 20px;"></div>
          <input
            :disabled="mode === 'view'"
            id="receipt-invoice"
            type="radio"
            value="invoice"
            style="display:none;"
            v-model="deliveryData.receiptType"
          />
          <label class="label-input-radio" for="receipt-invoice">{{
            deliveryData.receiptType === "invoice" ? "✔" : ""
          }}</label>
          <div class="com-anm22-app-text-l" style="margin:0 5px;">
            {{ $anm22.strLang(lang, "Invoice", "Fattura") }}
          </div>
        </div>
      </div>
    </div>
    <!-- INVOICING ADDRESS -->
    <template v-if="deliveryData.receiptType === 'invoice'">
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Company name", "Ragione sociale") }}
            </div>
            <input
              :disabled="mode === 'view'"
              class="input-elem com-anm22-app-input-text print-row"
              type="text"
              v-model="deliveryData.invoiceCompanyName"
            />
          </div>
        </div>
      </div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "VAT code", "P.IVA") }}
            </div>
            <input
              :disabled="mode === 'view'"
              class="input-elem com-anm22-app-input-text print-row"
              type="text"
              v-model="deliveryData.invoiceVatCode"
            />
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Tax code", "Codice fiscale") }}
            </div>
            <input
              :disabled="mode === 'view'"
              class="input-elem com-anm22-app-input-text print-row"
              type="text"
              v-model="deliveryData.invoiceTaxCode"
            />
          </div>
        </div>
      </div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Street", "Via") }}
            </div>
            <div
              class="wg-row input-elem print-row"
              style="align-items:center;"
            >
              <input
                :disabled="mode === 'view'"
                class="com-anm22-app-input-text row-add"
                style="width:155px;"
                type="text"
                :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
                v-model="address.addressStreet"
              />
              <input
                :disabled="mode === 'view'"
                class="com-anm22-app-input-text row-numb"
                style="width:40px;margin-left:5px;"
                type="text"
                placeholder="N."
                v-model="address.addressNumber"
              />
            </div>
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "City", "Città") }}
            </div>
            <input
              :disabled="mode === 'view'"
              class="input-elem com-anm22-app-input-text print-row"
              type="text"
              :placeholder="$anm22.strLang(lang, 'City', 'Città')"
              v-model="address.addressCity"
            />
          </div>
        </div>
      </div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "ZIP", "CAP") }}
            </div>
            <input
              :disabled="mode === 'view'"
              class="input-elem com-anm22-app-input-text print-row"
              type="text"
              :placeholder="$anm22.strLang(lang, 'ZIP', 'CAP')"
              v-model="address.addressZip"
            />
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "State", "Provincia") }}
            </div>
            <input
              :disabled="mode === 'view'"
              class="input-elem com-anm22-app-input-text print-row"
              type="text"
              :placeholder="$anm22.strLang(lang, 'State', 'Provincia')"
              v-model="address.addressState"
            />
          </div>
        </div>
      </div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Country", "Paese") }}
            </div>
            <select
              v-if="mode === 'edit'"
              class="input-elem com-anm22-app-select print-row"
              v-model="addressCountry"
            >
              <option value selected disabled hidden>{{
                $anm22.strLang(lang, "Select", "Seleziona")
              }}</option>
              <option
                v-for="(obj,
                key,
                index) in $anm22.tableClasses.worldCountry().getAll()"
                :key="'country-' + index"
                :value="key"
                >{{ obj[lang] }}</option
              >
            </select>
            <input
              v-else
              disabled
              class="input-elem com-anm22-app-input-text print-row"
              type="text"
              v-model="
                $anm22.tableClasses.worldCountry().getById(addressCountry)[lang]
              "
            />
          </div>
        </div>
      </div>
    </template>
    <div class="wg-row" style="padding:15px 5px 5px 5px;">
      <div class="com-anm22-app-text-m" style="font-weight: 600;">
        {{ $anm22.strLang(lang, "Order status", "Stato ordine") }}
      </div>
    </div>
    <!-- ACCONTO & SALDO -->
    <div
      v-if="
        mode === 'edit' &&
          (!this.project.category || this.project.category != 2)
      "
      class="wg-row"
    >
      <div
        class="wg-col wg-xs-12 wg-sm-6"
        v-if="!this.project.category || this.project.category != 2"
      >
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Deposit", "Acconto") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            placeholder="0"
            v-model="deliveryData.deposit"
          />
        </div>
      </div>
      <div
        class="wg-col wg-xs-12 wg-sm-6"
        v-if="this.project.category && this.project.category == 2"
      >
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Quotation", "Preventivo") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            placeholder="0"
            v-model="deliveryData.quotation"
          />
        </div>
      </div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row" style="height:36px;">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Balance", "Saldo") }}
          </div>
          <input
            class="input-elem com-anm22-app-input-text"
            type="text"
            placeholder="0"
            v-model="deliveryData.balance"
          />
        </div>
      </div>
    </div>
    <!-- ORDINE CONFERMATO -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row" style="height:36px;">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Order confirmed", "Ordine confermato") }}
          </div>
          <input
            id="confirmed"
            type="checkbox"
            :value="0"
            style="display:none;"
            v-model="deliveryData.confirmed"
          />
          <label class="label-input-radio" for="confirmed">{{
            deliveryData.confirmed ? "✔" : ""
          }}</label>
        </div>
      </div>
    </div>
    <!-- WARRANTY PROJECT -->
    <div
      v-if="this.project.category && this.project.category == 2"
      class="wg-row"
    >
      <div class="wg-col wg-xs-12 wg-sm-6"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row" style="height:36px;">
          <div class="com-anm22-app-text-m">
            {{
              $anm22.strLang(lang, "Warranty repair", "Intervento in garanzia")
            }}
          </div>
          <input
            id="warranty"
            type="checkbox"
            :value="0"
            style="display:none;"
            v-model="deliveryData.warranty"
          />
          <label class="label-input-radio" for="warranty">{{
            deliveryData.warranty ? "✔" : ""
          }}</label>
        </div>
      </div>
    </div>
    <!-- ONDA VISION ORDER STATUS -->
    <div class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row" style="height:36px;">
          <div
            v-if="project.orderNumber && project.orderNumber != 0"
            class="com-anm22-app-text-m"
          >
            {{
              $anm22.strLang(lang, "Onda Vision order", "Onda Vision ordine")
            }}
            {{ project.orderNumber }}
          </div>
          <div v-else class="com-anm22-app-text-m">
            {{
              $anm22.strLang(lang, "Onda Vision order", "Ordine Onda Vision")
            }}
            <div @click="sendProjectToOnda()" class="vircos-order-send-btn">
              <img :src="$anm22.icons.getWorldIcon('send')" />
              {{ $anm22.strLang(lang, "Send", "Invia") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- SHIPPING TYPE -->
    <div class="wg-row" style="padding:5px;">
      <div class="com-anm22-app-text-m" style="font-weight: 600;">
        {{ $anm22.strLang(lang, "Shipping", "Spedizione") }}
      </div>
    </div>
    <div class="wg-row">
      <div class="wg-col wg-xs-12">
        <div class="wg-row input-row">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Delivery method", "Metodo di consegna") }}
          </div>
          <select
            v-if="mode === 'edit'"
            class="input-elem com-anm22-app-select"
            v-model="deliveryData.deliveryType"
          >
            <option
              v-for="(dm, i) in deliveryTypes"
              :key="'dm-' + i"
              :value="dm.id"
              >{{ dm.label }}</option
            >
          </select>
          <template v-else>
            <input
              v-if="
                deliveryTypes.find((dm) => dm.id === deliveryData.deliveryType)
              "
              disabled
              class="input-elem com-anm22-app-input-text model-row"
              type="text"
              v-model="
                deliveryTypes.find((dm) => dm.id === deliveryData.deliveryType)
                  .label
              "
            />
          </template>
        </div>
      </div>
    </div>
    <!-- SPEDIZIONE A -->
    <div
      v-if="deliveryData.deliveryType === 'shipping'"
      class="wg-row input-row"
      style="margin-bottom: 0;"
    >
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Ship to", "Spedire a") }}
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <textarea
          class="input-elem com-anm22-app-textarea model-row"
          style="height:100px;width:100%;max-width:unset;margin-bottom: 0;"
          v-model.lazy="shippingAddress"
          :disabled="deliveryData.copyInvoicingAddress"
        ></textarea>
      </div>
    </div>
    <div v-if="deliveryData.deliveryType === 'shipping'" class="wg-row">
      <div class="wg-col wg-xs-12 wg-sm-6"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="wg-row input-row" style="height:36px;">
          <div class="com-anm22-app-text-m">
            {{
              $anm22.strLang(
                lang,
                "Copy invoicing address",
                "Copia indirizzo di fatturazione"
              )
            }}
          </div>
          <input
            id="copyInvoicingAddress"
            type="checkbox"
            :value="0"
            style="display:none;"
            v-model="deliveryData.copyInvoicingAddress"
          />
          <label class="label-input-radio" for="copyInvoicingAddress">{{
            deliveryData.copyInvoicingAddress ? "✔" : ""
          }}</label>
        </div>
      </div>
    </div>
    <!-- NOTE -->
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Notes", "Note") }}
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <textarea
          class="input-elem com-anm22-app-textarea model-row note-row"
          style="height:100px;width:100%;max-width:unset;"
          v-model.lazy="deliveryData.notes"
        ></textarea>
      </div>
    </div>
    <!-- INVIO NOTIFICHE -->
    <div
      v-if="docs.data.company == 'vrs' || docs.data.company == 'rvt'"
      class="wg-row input-row no-print"
    >
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">
          {{
            $anm22.strLang(lang, "Thank you email", "Email di ringraziamento")
          }}
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div
        v-if="notificationSended || deliveryData.notificationThankYou"
        class="wg-col wg-xs-12 wg-sm-6"
      >
        <div class="vircos-notification-sended">
          <img :src="$anm22.icons.getWorldIcon('check')" />
          {{ $anm22.strLang(lang, "Sended", "Inviata") }}
          {{
            $moment
              .unix(deliveryData.notificationThankYou)
              .format("DD/MM/YYYY HH:mm")
          }}
        </div>
      </div>
      <div v-else class="wg-col wg-xs-12 wg-sm-6">
        <div
          @click="sendThankYouNotification()"
          class="vircos-notification-send-btn"
        >
          <img :src="$anm22.icons.getWorldIcon('send')" />
          {{ $anm22.strLang(lang, "Send", "Invia") }}
        </div>
      </div>
    </div>
    <div class="wg-row input-row">
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Last edit", "Ultima modifica") }}
        </div>
      </div>
      <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
      <div class="wg-col wg-xs-12 wg-sm-6">
        <div class="com-anm22-app-text-m">
          {{ lastEditDate + " " + lastEditUser }}
        </div>
      </div>
    </div>
    <div class="vertical-height-div"></div>
    <div v-if="mode === 'edit'" class="wg-row">
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Save', 'Salva')"
        @click="saveContact"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    projectId: [Number, String],
    docs: Object,
    mode: {
      type: String,
      default: "edit",
    },
  },
  data() {
    return {
      formData: {},
      deliveryData: {},
      showCalendar: false,
      // Per gestione calendario
      now: this.$moment(),
      offset: 0,
      notificationSended: false,
      products: [],
      productCategories: [],
      customer: {},
      address: {},
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
    }),
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
    deliveryDate() {
      let string = this.deliveryData.deliveryDate
        ? this.$moment
            .unix(this.deliveryData.deliveryDate)
            .utc()
            .format("DD/MM/YYYY")
        : this.$anm22.strLang(this.lang, "Not set", "Non impostata");
      return string;
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.deliveryData.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.deliveryData.lastUpdate
        ? this.$moment
            .unix(this.deliveryData.lastUpdate)
            .format("DD/MM/YYYY HH:mm")
        : "";
    },
    month() {
      return this.now.clone().add(this.offset, "months");
    },
    deliveryTypes() {
      return this.$anm22["vircos_getDeliveryTypes"](this);
    },
    deliveryCarriers() {
      return this.$anm22["vircos_getDeliveryCarriers"](this);
    },
    suitProducts() {
      return this.products.filter((p) => p.category == 10);
    },
    airbagProducts() {
      return this.products.filter((p) => p.category == 9);
    },
    accessoryProducts() {
      return this.products.filter((p) => p.category == 8);
    },
    totalPrice() {
      let totalPrice = 0;
      if (this.deliveryData) {
        // Suit price
        if (this.deliveryData.price) {
          totalPrice += parseFloat(this.deliveryData.price);
        }
        // AirBag price
        if (this.deliveryData.airbagPrice) {
          totalPrice += parseFloat(this.deliveryData.airbagPrice);
        }
        // Accessories prices
        if (this.deliveryData.accessories) {
          let i;
          for (i = 0; i < this.deliveryData.accessories.length; i++) {
            if (this.deliveryData.accessories[i].price) {
              totalPrice += parseFloat(this.deliveryData.accessories[i].price);
            }
          }
        }
        // Delivery price
        if (
          this.deliveryData.deliveryType &&
          this.deliveryData.deliveryType === "shipping" &&
          this.deliveryData.deliveryPrice
        ) {
          totalPrice += parseFloat(this.deliveryData.deliveryPrice);
        }
      }
      return totalPrice;
    },
    addressCountry: {
      get() {
        return this.address.addressCountry ? this.address.addressCountry : "";
      },
      set(newVal) {
        this.$set(this.address, "addressCountry", newVal);
      },
    },
    shippingAddress: {
      get() {
        if (this.deliveryData.copyInvoicingAddress == true) {
          if (this.address) {
            return (
              (this.deliveryData.invoiceCompanyName
                ? this.deliveryData.invoiceCompanyName
                : "") +
              "\n" +
              this.address.addressStreet +
              " " +
              this.address.addressNumber +
              "\n" +
              this.address.addressZip +
              " " +
              this.address.addressCity +
              " (" +
              this.address.addressState +
              ")\n" +
              this.addressCountry
            );
          } else {
            return "";
          }
        } else {
          return this.deliveryData.shippingAddress;
        }
      },
      set(newVal) {
        this.deliveryData.shippingAddress = newVal;
      },
    },
  },
  methods: {
    openCalendar() {
      this.showCalendar = true;
    },
    setDeliveryDate(newDate) {
      let ts = this.$moment.utc(newDate).unix();
      this.$set(this.deliveryData, "deliveryDate", ts);
      this.showCalendar = false;
    },
    saveContact() {
      if (this.project.customers.length > 0) {
        // Il contatto è già presente, salvo eventuali modifiche e poi salvo il documento di Vircos
        this.$http
          .post(
            "vircos/editContact",
            {
              projectId: this.project.idWorldProject,
              contact: this.customer,
              address: this.address,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.customer = response.data.contact;
            this.address = response.data.place;
            return Promise.all([
              this.$store.dispatch("contacts/update", {
                vlf: this.$vlf("contacts"),
                objs: [response.data.contact],
              }),
              this.$store.dispatch("places/update", {
                vlf: this.$vlf("places"),
                objs: [response.data.place],
              }),
            ]);
          })
          .then((result) => {
            this.saveForm();
          })
          .catch((error) => console.log(error));
      } else {
        this.$http
          .post(
            "vircos/newContact",
            {
              projectId: this.project.idWorldProject,
              contact: this.customer,
              address: this.address,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            /* Aggiungo il nuovo cliente al progetto */
            let project = { ...this.project };
            project.customers.push(response.data.contact.idContactsContact);
            this.customer = response.data.contact;
            this.address = response.data.place;
            /* Aggiorno il db locale */
            return Promise.all([
              this.$store.dispatch("contacts/update", {
                vlf: this.$vlf("contacts"),
                objs: [response.data.contact],
              }),
              this.$store.dispatch("places/update", {
                vlf: this.$vlf("places"),
                objs: [response.data.place],
              }),
            ]);
          })
          .then((result) => {
            this.saveForm();
          })
          .catch((error) => {
            // Offline
          });
      }
    },
    saveForm() {
      const docs = { ...this.docs };

      // Address
      docs.data.address = this.address;

      docs.delivery = this.deliveryData;
      docs.delivery.lastUser = this.user.idWorldUser;
      docs.delivery.lastUpdate = this.$moment().unix();
      this.$emit("save", docs);
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    sendThankYouNotification() {
      if (this.docs.data.email) {
        this.deliveryData.notificationThankYou = this.$moment().unix();
        this.notificationSended = true;
        this.$http
          .post(
            "vircos/sendThankYouNotification",
            {
              projectId: this.project.idWorldProject,
              email: this.docs.data.email,
              name: this.docs.data.name,
              surname: this.docs.data.surname,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      } else {
        console.log("Notification: Missing customer e-mail");
      }
    },
    loadWarehouseData() {
      this.$http
        .get("products")
        .then((response) => {
          this.products = response.data.products;
          this.productCategories = response.data.categories;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addAccessory() {
      this.deliveryData.accessories = [
        ...this.deliveryData.accessories,
        {
          product: null,
          price: null,
        },
      ];
    },
    deleteAccessory(key) {
      this.deliveryData.accessories.splice(key, 1);
    },
    sendProjectToOnda() {
      this.$http
        .post(
          "vircos/onda-send-order?projectId=" + this.project.idWorldProject,
          null,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response && response.data && response.data.orderNumber) {
            this.project.orderNumber = response.data.orderNumber;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.loadWarehouseData();

    /* Get customer data */
    if (this.project.customers.length > 0) {
      this.customer = {
        ...this.$store.getters["contacts/get"](this.project.customers[0]),
      };
    }
    if (
      Object.keys(this.customer).length > 0 &&
      this.customer.places.length > 0
    ) {
      this.address = {
        ...this.$store.getters["places/get"](this.customer.places[0]),
      };
    }

    this.formData = { ...this.docs.data };

    this.deliveryData = { ...this.docs.delivery };
    if (this.deliveryData.notes && Array.isArray(this.deliveryData.notes)) {
      if (this.deliveryData.notes.length > 0) {
        this.deliveryData.notes = this.deliveryData.notes[
          this.deliveryData.notes.length - 1
        ].note;
      } else {
        this.deliveryData.notes = "";
      }
    }
    if (!this.deliveryData.suitModel) {
      this.deliveryData.suitModel = null;
    }
    if (!this.deliveryData.airbag) {
      this.deliveryData.airbag = null;
    }
  },
  components: {
    VircosCalendar: () =>
      import(/* webpackChunkName: "custom-16" */ "./VircosCalendar.vue"),
  },
};
</script>

<style lang="scss" scoped>
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
}
.input-elem {
  width: 200px;
}
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.hidden-input {
  cursor: pointer;
  border-radius: 4px;
  padding: 5px;
  min-height: 36px;
  align-items: center;
  flex-wrap: nowrap;
  &:hover {
    background-color: #eee;
  }
}
.vircos-order-send-btn,
.vircos-notification-send-btn {
  cursor: pointer;
  position: relative;
  padding: 6px 12px 6px 32px;
  background-color: #eee;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  display: inline-block;

  &:hover {
    background-color: #ddd;
  }

  img {
    position: absolute;
    left: 10px;
    top: 6px;
    width: 16px;
  }
}
.vircos-notification-sended {
  position: relative;
  padding: 6px 12px 6px 22px;
  color: #000;
  border-radius: 6px;
  font-size: 14px;
  display: inline-block;

  img {
    position: absolute;
    left: 0px;
    top: 6px;
    width: 16px;
  }
}
@media print {
  .model-row {
    width: 541px !important;
    max-width: 541px !important;
  }
  .note-row {
    height: 541px !important;
  }

  .no-print {
    display: none;
  }
}
</style>
